module.exports = __webpack_public_path__ + "img/162.laptop.9cd7219a.svg";